import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { btnCva, btnIconCva } from "../../../ui/button"
import { CourseCard } from "../../cards/course-card"
import { homePageData } from "../../../constants/home"
import { events } from "../../../constants/analytics"
import cn from "../../../utils/classname"
import IconRenderer from "../../../ui/icon/icon-renderer"
import { capture } from "../../../services/posthog"

const data = {
  title: "Explore over 700 courses",
  subTitle:
    "Browse our comprehensive collection of courses, books, and tutorials on a wide range of development and design topics.",
}

const ExploreCourses = ({ covers }) => {
  const { courses } = useStaticQuery(graphql`
    {
      courses: allSpLatestCourse(limit: 6) {
        nodes {
          id
          title
          url
          duration
          topics
          slug
          rating
          localImage {
            childImageSharp {
              gatsbyImageData(
                width: 282
                height: 180
                layout: CONSTRAINED
                placeholder: BLURRED
              )
            }
          }
        }
      }
    }
  `)

  return (
    <div className="mt-11 sm:mt-20 container-lg relative">
      <div className="text-neutral-12 text-jar-6 font-semibold mb-2 sm:mb-1">
        {data.title}
      </div>
      <p className="text-jar-4 text-neutral-11">{data.subTitle}</p>
      <div className="w-[calc(100%+32px)] -mx-4 xl:mx-0 xl:w-full">
        <div
          className={cn(
            "px-4 xl:px-0 mt-8 sm:mt-10 flex gap-6 overflow-x-auto snap-x snap-mandatory lg:grid lg:grid-cols-3 lg:gap-y-10",
            "pb-5 lg:pb-0"
          )}
        >
          {courses.nodes.map(({ title, slug, url, rating, localImage }) => (
            <CourseCard
              key={slug}
              url={url}
              name={title}
              rating={rating}
              cover={
                covers[slug] || localImage?.childImageSharp?.gatsbyImageData
              }
            />
          ))}
        </div>
      </div>

      <div className="w-[calc(100%+32px)] -mx-4 lg:w-full lg:mx-0 flex flex-col bg-neutral-2 lg:rounded-2xl overflow-hidden relative py-12 md:py-8 mt-3 sm:mt-5 lg:mt-10">
        <div className="px-4 lg:px-8">
          <div className="max-w-[414px] z-10 relative">
            <div className="text-jar-6 font-semibold">Looking for more?</div>
            <p className="text-jar-4 text-neutral-11 mt-1">
              Browse our comprehensive collection of courses, books, and
              tutorials on a wide range of topics.
            </p>
          </div>
          <a
            id="home-browse-premium-library"
            className={cn(
              btnCva({ variant: "solid", theme: "neutral", size: 3 }),
              "shrink-0 w-full sm:w-fit mt-6"
            )}
            href={homePageData.links.browseLibrary}
            onClick={() => {
              capture(events.clicked_browse_library)
            }}
          >
            <span>Browse Library</span>
            <IconRenderer
              className={btnIconCva({ size: 3 })}
              iconType={"other"}
              iconName={"ChevronRightSmall"}
            />
          </a>
        </div>

        <div className="mt-12 md:mt-0 md:absolute md:right-0 md:top-0 md:bottom-0  md:overflow-hidden">
          <div className="hidden md:flex items-center">
            <StaticImage
              src="../../../images/home/learn-more/courses-list-hq.png"
              alt="Course List"
              quality={100}
              width={435}
              height={208}
            />
          </div>
          <div className="md:hidden relative">
            <StaticImage
              src="../../../images/home/learn-more/courses-list-mobile-v1.png"
              alt="Course List"
              quality={100}
              objectFit="none"
              className="w-full"
            />
            <Link
              className={cn(
                "absolute text-jar-3 font-medium text-center backdrop-blur-xl bg-neutral-inverse-alpha-11 rounded-lg",
                "left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-max p-2.5"
              )}
              to="/premium/library/"
            >
              Collection of more than 700 courses
            </Link>
          </div>
        </div>
      </div>
      <Link
        className={cn(
          "absolute text-jar-3 font-medium text-center backdrop-blur-xl bg-neutral-inverse-alpha-11 rounded-lg",
          "right-8 bottom-8 w-max p-2.5 hidden md:block"
        )}
        to="/premium/library/"
      >
        Collection of more than 700 courses
      </Link>
    </div>
  )
}

export default ExploreCourses
